const vimeoPlayActions = document?.querySelectorAll('.vimeo__play');
vimeoPlayActions.forEach(function (vimeoPlay) {
    vimeoPlay?.addEventListener('click', function () {
        this.closest('.vimeo__img-wrap').classList.toggle('vimeo__img-iframe');
    });
});
